import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
type PremiumPlanPriceProps = {
  currencySymbol: string;
  price: string;
  originalPrice?: string;
  discountPercent?: number;
  /** Already formatted duration suffix, e.g. `/annual` or ` /annual`. */
  suffix?: string;
};

/**
 * Renders a plan price inside the caller's text element. Without a discount it outputs exactly the
 * plain `{symbol}{price}{suffix}` text, so the caller's existing markup is unchanged.
 */
const PremiumPlanPrice = t0 => {
  const $ = _c(24);
  const {
    currencySymbol,
    price,
    originalPrice,
    discountPercent,
    suffix
  } = t0;
  const t = useTranslations();
  if (originalPrice == null || discountPercent == null) {
    let t1;
    if ($[0] !== currencySymbol || $[1] !== price || $[2] !== suffix) {
      t1 = <>{currencySymbol}{price}{suffix}</>;
      $[0] = currencySymbol;
      $[1] = price;
      $[2] = suffix;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== currencySymbol || $[5] !== originalPrice) {
    t1 = <s>{currencySymbol}{originalPrice}</s>;
    $[4] = currencySymbol;
    $[5] = originalPrice;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== currencySymbol || $[8] !== price) {
    t2 = <span className="text-vive-brand-50">{currencySymbol}{price}</span>;
    $[7] = currencySymbol;
    $[8] = price;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== suffix || $[11] !== t2) {
    t3 = <span>{t2}{suffix}</span>;
    $[10] = suffix;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t3) {
    t4 = <span className="flex flex-wrap items-baseline gap-x-2">{t1}{t3}</span>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== discountPercent || $[17] !== t) {
    t5 = t("premium-plan-section.discount-off", {
      percent: discountPercent
    });
    $[16] = discountPercent;
    $[17] = t;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t5) {
    t6 = <span className="subheader4-omni-styles text-vive-discount">{t5}</span>;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t4 || $[22] !== t6) {
    t7 = <span className="inline-flex flex-col items-start">{t4}{t6}</span>;
    $[21] = t4;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export default PremiumPlanPrice;